// extracted by mini-css-extract-plugin
module.exports = {"title":"ArticlesWithSelectionsView_title__chpVc","footnote":"ArticlesWithSelectionsView_footnote__09IUI"};